import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaConfiguracionRegistrosPatronalesComponent {
  empresaId = undefined
  registrosPatronales

  constructor (EmpresaConfiguracionRegistrosPatronales) {
    this.EmpresaConfiguracionRegistrosPatronales = EmpresaConfiguracionRegistrosPatronales
  }

  $onInit() {
    this.promise = this.EmpresaConfiguracionRegistrosPatronales.get(this.empresaId)
      .then(({data}) => (this.registrosPatronales = data))
  }

  agregar() {
    this.agregarRegistroPatronal = true
  }

  procesar(data) {
    this.agregarRegistroPatronal = false
    if(data) {
      this.registrosPatronales = [...this.registrosPatronales, data]
    }
  }
}

module.component('empresaConfiguracionRegistrosPatronales', {
  controller: EmpresaConfiguracionRegistrosPatronalesComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/registrosPatronales/component.js